import React, { useEffect, useRef, useState } from "react";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import de from "date-fns/locale/de";

import DebugOutput from "./DebugOutput";
import DeineNaechsteBuchung from "./DeineNaechsteBuchung";
import Faq from "./Faq";
import FixedNews from "./FixedNews";
import Footer from "./Footer";
import Header from "./Header";
import HotNews from "./HotNews";
import Platzbelegung from "./Platzbelegung";
import DialogGast from "../dialogs/DialogGast";

import { _common } from "../common";
import { ServerInterface } from "../ServerInterface";

const common = _common;

registerLocale("de", de);

let anzeigeTafelPhase = 0;
(window as any).mainScale = 1;

export default function Main() {
  const d1 = new Date();
  const d2 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
  const [startDate, setStartDate] = useState<Date>(d2);
  const [redraw, setRedraw] = useState(1);
  const interval = useRef<number | undefined>();

  const PlatzbelegungPage1Ref = useRef<HTMLDivElement>(null);

  const scrollPos = useRef<number>(0);

  function onRedraw() {
    const x = new Date().getTime();
    scrollPos.current = window.scrollY;
    setRedraw(x);
  }

  useEffect(() => {
    window.scrollTo(0, scrollPos.current);
  });

  useEffect(() => {
    setTimeout(() => {
      const outer = PlatzbelegungPage1Ref.current;
      if (outer) {
        const inner = outer.querySelector("#innerMain");
        if (inner) {
          const f = Math.min(1, outer.clientWidth / inner.clientWidth);

          const r1 = inner.getBoundingClientRect();

          console.log(`scale ${f} ${outer.clientWidth} ${r1.width}  `);

          const lastScale = (window as any).mainScale;
          (window as any).mainScale = f;

          (inner as any).style.transform = `scale(${f})`;
          (inner as any).style.transformOrigin = "top";

          const r2 = outer.getBoundingClientRect();
          // (outer as any).style.height = `${(r2.height * f) / lastScale}px`;
        }
      }
    }, 100);
  });


  async function init() {
    let interval: any | undefined;

    // if (false && window.location.search.toLocaleLowerCase().indexOf("force") < 0) {
    //   //
    //   // 1.) check if User has a registartion for webpush
    //   //


    //   window.location.href = "/registerwebpush"

    // }


    const sD1 = await ServerInterface.getOpeningDate();
    const jD1 = JSON.parse(sD1);
    if (jD1 && jD1.date) {
      common.openingDate = new Date(jD1.date);
      if (common.openingDate > new Date()) {
        onRedraw();
      }
    } else {
      common.openingDate = new Date();
    }



    interval = window.setInterval(() => {
      if (anzeigeTafelPhase == 0) {
        onRedraw();
      }
    }, 10 * 60 * 1000);

    return () => {
      clearInterval(interval);
    };
  }

  useEffect(() => {
    init()
  }, []);

  console.log("render main", startDate);

  const TopStyle: any = {
    position: "absolute",
    left: "0px",
    right: "0px",
    width: "100%",
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    marginTop: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#fff",
    transition: "opacity 1s ease-in-out",
  };

  // if (common.anzeigeTafelMode) {
  //   // TopStyle.transform = "rotate(90deg)  scale(1.2)"; //  translate(-50px, -50px)";
  //   // TopStyle.transformOrigin = "top left";
  //   TopStyle.height = `100vw`; // wg scale 1.2`100vw`;
  //   TopStyle.width = `100vh`;

  //   TopStyle.transform = "translate(100vw, 0px) rotate(90deg) ";
  //   TopStyle.transformOrigin = "left top";
  //   TopStyle.justifyContent = undefined;
  //   TopStyle.overflow = "hidden";
  // }

  //
  // 3 Phasen (0..2) a 15 sekunden
  // in Phase 2 wird PlatzbelegungPage2 angezeigt
  //

  return (
    <div>
      <div ref={PlatzbelegungPage1Ref} key="PlatzbelegungPage1" id="top" style={{ ...TopStyle, opacity: "1" }}>
        <div style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "max-content"
        }}>
          <Header />

        </div>

        {redraw && (
          <div
            id="innerMain"
            style={{
              position: "relative",
              width: "max-content",
              maxWidth: !common.anzeigeTafelMode ? "600px" : undefined,
              display: "flex",
              flexDirection: "column",
              height: "max-content",
            }}
          >

            <div style={{ paddingLeft: "5px", paddingRight: "5px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <DeineNaechsteBuchung onReDraw={() => setRedraw(redraw + 1)} redraw={redraw} />
              {/* {!common.anzeigeTafelMode && <FixedNews />} */}
              <HotNews />
              <Faq />

              {common.clubhausMode && (
                <div
                  style={{
                    zIndex: "1",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: "20px",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "lightblue",
                    }}
                    className="btn"
                    onClick={() => setStartDate(new Date())}
                  >
                    <div style={{ whiteSpace: "nowrap" }}>Wieder ab heute zeigen</div>
                  </button>

                  <DatePicker
                    dateFormat="dd.MM.yyyy"
                    locale="de"
                    selected={startDate}
                    onSelect={(date) => {
                      if (date) {
                        setStartDate(date);
                      }
                    }} //when day is clicked
                    onChange={(date) => {
                      if (date) {
                        setStartDate(date);
                      }
                    }} //only when value has changed
                  />
                </div>
              )}

              <Platzbelegung startDate={startDate} onReDraw={onRedraw} />
            </div>
            <Footer />
          </div>
        )}
      </div>
    </div>
  );
}
